import React from 'react';
import { AppButton, Box, Text, useWatch } from '@common-fe/common-fe';
interface Props {
  onClick?: () => void;
}
const RoleSetupFinal: React.FC<Props> = ({ onClick }) => {
  const name = useWatch({
    name: 'name',
  });
  return (
    <Box
      width={{ max: '450px' }}
      round="container1Round"
      direction='column'
      pad="l"
      background="canvas"
      border={{ size: 'small', color: 'border2' }}
    >
      <Text size="2xl" color="titleText" weight={700} margin={{ bottom: 'l' }}>
        {name}
      </Text>
      <Box>
        <AppButton width='100%' type="submit" onClick={onClick}>Save</AppButton>
      </Box>
    </Box>
  );
};

export default RoleSetupFinal;
